<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none" viewBox="0 0 42 42">
  <path fill-rule="evenodd" d="M12 14h2v6h4v-6h2v14h-2v-6h-4v6h-2V14Zm12 2h4v1h2v-1a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4v-4Zm0 6h4v4h-4v-4Z" clip-rule="evenodd"/>
</svg>
